import { differenceInHours, isValid, parseISO, format } from "date-fns";
import {
  InfoOutlinedCircle,
  TimerBorderOutlineCircleWarning,
  TimerBorderOutlineCircleError,
} from "../assets/svgs";

export const getExpiryStatus = expiryDate => {
  if (!expiryDate) {
    return {
      days: null,
      hours: null,
      urgency: "low",
      bgColor: "success-50",
      icon: InfoOutlinedCircle,
      i18nHeadingKey: "",
      i18nDescriptionKey: "",
      formattedExpiry: "-",
    };
  }

  const expiry = parseISO(expiryDate);

  if (!isValid(expiry)) {
    return {
      days: null,
      hours: null,
      urgency: "low",
      bgColor: "success-50",
      icon: InfoOutlinedCircle,
      i18nHeadingKey: "",
      i18nDescriptionKey: "",
      formattedExpiry: "-",
    };
  }

  const now = new Date();
  const totalHours = differenceInHours(expiry, now);

  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  console.log(totalHours);

  const formattedExpiry = format(expiry, "dd MMM yyyy");

  let bgColor = "success-50";
  let icon = InfoOutlinedCircle;
  let urgency = "low";
  let i18nHeadingKey = "";
  let i18nDescriptionKey = "";

  if (days > 5) {
    urgency = "low";
    bgColor = "success-50";
    icon = InfoOutlinedCircle;
    i18nHeadingKey = "waiting_for_signature.low_heading";
    i18nDescriptionKey = "waiting_for_signature.low_description";
  } else if (days > 1 && days <= 5) {
    urgency = "medium";
    bgColor = "warning-50";
    icon = TimerBorderOutlineCircleWarning;
    i18nHeadingKey = "waiting_for_signature.medium_heading";
    i18nDescriptionKey = "waiting_for_signature.medium_description";
  } else if (totalHours <= 24 && totalHours > 3) {
    urgency = "high";
    bgColor = "danger-50";
    icon = TimerBorderOutlineCircleError;
    i18nHeadingKey = "waiting_for_signature.high_heading";
    i18nDescriptionKey = "waiting_for_signature.high_description";
  } else if (totalHours <= 3) {
    urgency = "critical";
    bgColor = "danger-50";
    icon = TimerBorderOutlineCircleError;
    i18nHeadingKey = "waiting_for_signature.high_heading";
    i18nDescriptionKey = "waiting_for_signature.high_description";
  }

  return {
    days,
    hours,
    urgency,
    bgColor,
    icon,
    i18nHeadingKey,
    i18nDescriptionKey,
    formattedExpiry,
  };
};
